export enum PageId {
  INTRO = 'intro',
  SERIES = 'series',
  MOVIES = 'movies',
  YOUTUBE = 'youtube',
  COLLECTION = 'collection',
  HISTORY = 'history',
}

export enum WordsView {
  CARDS = 'cards',
  LIST = 'list',
  BASE = 'base'
}

export interface RouteHandle {
  pageId?: PageId;
  auth?: boolean;
}
